<template>
    <div>
        <video autoplay muted loop id="myVideo">
            <source src="https://alfiobardolla.com/video/video-per-nuovo-sito.mp4" type="video/mp4" style="width:100%;">
        </video>
        <div class="limiter">
            <!-- The video -->
            <!-- Optional: some overlay text to describe the video -->

            <div class="container-login100 ">
                <div class="wrap-login100">

                        <span class="login100-form-title p-b-34 p-t-27">
						<img src="/img/logo_abtool_bianco.svg" width="200">
					</span>

                        <div class="contact100-form-checkbox abtg__login-remember" style="font-size:130%;color:white">
                            <span v-if="!action">
                            Ci dispiace tu non voglia più ricevere email.<br><br>
                            Premi qui sotto per annullare l'invio delle notifiche dal sito abtgtool.com (Real Estate Pro).
                            </span>
                            <span v-else>
                                Perfetto! Hai annullato l'iscrizione alle notifiche di Abtgtool.com (Real Estate Pro).
                            </span>
                        </div>
                        <div class="container-login100-form-btn" v-if="!action">
                            <button class="login100-form-btn"
                            @click="unsubscribe">
                                Conferma
                            </button>
                        </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'

    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'user/getField',
        mutationType: 'user/updateField',
    });

    export default {
        mixins: [mixin],

        data: function () {
            return {
                action: false,
            }
        },

        computed: {

        },
        created: function () {

        },
        methods: {
            unsubscribe(){
                this.action =true;
                this.$store.dispatch('user/unsubscribe', {token: this.$route.params.privacy_token})
            }



        }
    }
</script>